/* eslint-disable no-param-reassign */
import Vue from 'vue';
import * as math from 'mathjs';

const ValidationPlugin = {
  install(/* vue */) {
    Vue.mixin({
      computed: {
        $rules() {
          return {
            realistic: value => {
              return value == null || isNaN(value) || math.evaluate('value < 1000000', { value }) || 'Arvo on liian iso';
            },
            number: value => {
              const re = /^[0-9.,]*$/
              return value == null || value.length === 0 || re.test(value) || "Kentän tulee olla numero";
            },
            required: value => !!value || "Kenttä on pakollinen.",
            email: email => {
              let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return !!re.test(String(email).toLowerCase()) || "Kentän tulee olla sähköpostiosoite.";
            },
          };
        },
      },
    });
  },
};

export default ValidationPlugin;
